import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Reviews from "@/components/Reviews";
import PromoBanner from "@/components/PromoBanner";
import Services from "@/components/Services";
import Accessories from "@/components/Accessories";
import Benefits from "@/components/Benefits";
import KidsAudiology from "@/components/KidsAudiology";
import Education from "@/components/Education";
import Brands from "@/components/Brands";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";

export default function Landing() {
  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <PromoBanner />
        <Reviews />
        <Services />
        <Benefits />
        <Accessories />
        <KidsAudiology />
        <Education />
        <Brands />
        <About />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
